import Modal from '../../common/modal';
import preloadTemplate from './../preload-template';
import Network from '../../utils/network';
import Init from './init';

class Loader {
    /**
     * @param {String} loadLink
     * @param {Object} formData
     * @param {String} initType
     */
    constructor({loadLink = '', formData = {}, initType = 'base'}) {
        this.loadLink = loadLink;
        this.formData = formData;
        this.initType = initType;
        this.render();
    }

    /**
     * @param {{loadLink: String}|{loadLink: String, formData: Object, initType:String}} data
     * @return {Loader}
     */
    static run(data) {
        return new Loader(data);
    }

    render() {
        const openModal = Modal.run({content: preloadTemplate()});

        Network.call({
            link: this.loadLink,
            data: this.formData,
            method: 'POST',
            dataFormName: false,
            loaderDetach: true,
        }).then((r) => {
            let {error, html, formData = {}} = r;

            if (error === false) {
                openModal.insertHtml(html).then(() => {
                    Init.run({
                        typeName: this.initType,
                        data: {
                            modal: openModal,
                            formData,
                        },
                    });
                }).then(() => {
                    if (openModal.activeModal.offsetHeight > 400) {
                        openModal.activeModal.style.top = '83px';
                    }
                });
            } else {
                openModal.showError();
            }
        });
    }
}

export default Loader;
